<template>
    <div>
    </div>
</template>

<script>
    import {canvasHelper} from "../../mixins/canvasHelper";

    export default {
        name: 'CanvasQuadrant',
        mixins: [canvasHelper],
        props: {
            targetQuadrant: {
                type: Number,
                required: true
            }
        },
      computed: {
            perspective() {
                return this.config.quadrants[this.targetQuadrant]
            },
            blobs() {
                return this.$store.getters['blobs/getRadarBlobs'](this.radar.id).filter(b => b.quadrant === this.targetQuadrant);
            },
            quadrantLabels() {
                return [this.targetQuadrant]
            }
        },
        watch: {
        targetQuadrant: function () {
                // reset blobs and redraw whole quadrant
                this.resetBlobs();
                this.draw();
            }
        }
    }
</script>

